import BaseModel from '../../../../base/base_model';
import {GEO} from './geo_hybrid_consts';

import Strings from '../../../../utils/strings';



/**
 *
 */

class GeoModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GeoModel';


    init(params) {
        super.init(params);
    }


    /**
     * @get the Function Name
     */
    getFuncName(data) {
        let fn = data[GEO.CB_FN];

        return (undefined !== fn) ? fn : '';
    }

    isValidData(data){
        try {
            let dt = JSON.stringify(data);
            return 'undefine' !== data && dt.length > 2;
        }
        catch (e) {
            return false;
        }
    }

    geoLocationRes(data) {
        let res = data[GEO.RES_DATA];
        let datatmp = decodeURIComponent(res);

        let string = new Strings(datatmp);

        if(string.isEmpty()){
            return '';
        }

        datatmp = string.stripslashes();
        string.setString(datatmp);
        datatmp = string.replaceAll(GEO.CHANGE_TO, GEO.CHANGE_FROM);
        let type = data[GEO.RES_TYPE];

        let AllData = JSON.stringify({'type': type, 'data': datatmp});

        return AllData;
    }

}

export default GeoModel;